import { startCase } from 'lodash';

import { PlanKind, PeriodType, GoGoRole } from '@/gql/graphql';
import type { ListType } from '@/models/app';

export const roleOptions: ListType[] = Object.values(GoGoRole).map((role, index) => ({
  id: index + 1,
  key: role,
  label: startCase(String(role)),
}));

export const partnerPlanList: ListType[] = [
  { id: 1, key: 'basic', label: 'Basic' },
  { id: 2, key: 'premium', label: 'Premium' },
];

export const planKindOptions: ListType[] = Object.values(PlanKind).map((kind, index) => ({
  id: index + 1,
  key: kind,
  label: startCase(kind),
}));

export const periodTypeOptions: ListType[] = Object.values(PeriodType).map((period, index) => ({
  id: index + 1,
  key: period,
  label: startCase(period.toLowerCase()),
}));

export const prioritySupportLevels = ['low', 'medium', 'high', 'first'] as const;

export type PrioritySupportLevel = (typeof prioritySupportLevels)[number];

export const defaultPrioritySupportLevel: PrioritySupportLevel = prioritySupportLevels[0];

export const prioritySupportOptions: ListType[] = prioritySupportLevels.map((level, index) => ({
  id: index + 1,
  key: level,
  label: startCase(level),
}));

export const normalizePrioritySupportLevel = (value?: string | null): PrioritySupportLevel => {
  const normalized = (value ?? '').trim().toLowerCase();
  return prioritySupportLevels.includes(normalized as PrioritySupportLevel)
    ? (normalized as PrioritySupportLevel)
    : defaultPrioritySupportLevel;
};
